export default {
  IMG_DEFAULT: 'https://img3.gemtec.ltd/zhenshi_defult.jpg',
  IMG_DEFAULT_SM: 'https://img3.gemtec.ltd/zhenshi_defult.jpg',
  IMG_DEFAULT_LG: 'https://img3.gemtec.ltd/zhenshi_defult.jpg',
  IMG_ERROR: 'https://img3.gemtec.ltd/zhenshi_defult.jpg',
  IMG_ERROR_SM: 'https://img3.gemtec.ltd/zhenshi_defult.jpg',
  IMG_ERROR_LG: 'https://img3.gemtec.ltd/zhenshi_defult.jpg',
}